export const PKG_NAME = "@hpcc-js/util";
export const PKG_VERSION = "3.2.0";
export const BUILD_VERSION = "3.2.1";
